// extracted by mini-css-extract-plugin
export default {"wrapper":"Jbkbc","title":"Bpo56","rules":"sPlC2","evenCount":"Mus_q","oddCount":"i_aWb","rule":"VU0kn","image":"jLU3A","text":"wrlWo","link":"e7xRK"};